import initialState from './initialState'
import * as types from '../actions/actionTypes'

export default function isLoadingReducer(state = initialState.isLoading, action: any) {
  switch (action.type) {
    case types.LOAD_SUBSCRIPTIONREQUESTS_SUCCESS:
      return false;
    case types.LOAD_SUBSCRIPTIONS_SUCCESS:
      return false;
    case types.START_LOAD_SUBSCRIPTIONREQUEST:
      return true;
    case types.START_LOAD_SUBSCRIPTION:
      return true;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/reducers/isLoadingReducer.tsx